export default {"src":"/_next/static/media/mountain.657e869d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};